import { Button } from "../../components/Button";
import { HeroWrapper, HeroBadge, HeroTitle, HeroCtas, HeroCTA, HeroContent, HeroImage, HeroSubtitle } from "../../components/pages/Hero";
import Head from "next/head";
import { HugeCTACTA, HugeCTATitle, HugeCTAWrapper } from "../../components/pages/HugeCTA";
import { GetAllDatoImages, convertNumberedKeysToArrays, replaceImageValues } from "../../components/helpers";
import { GradientDivider, GradientDividerTop } from "../../components/GradientDivider";
import { BenefitsCard, BenefitsCardImage, BenefitsCards, BenefitsSubtitle, BenefitsTitle, BenefitsWrapper } from "../../components/pages/Benefits";
import { useStoreUTM } from "../../components/hooks/storeUTM";
import { FeatureTitle, FeaturesCard, FeaturesCardDescription, FeaturesCardTitle, FeaturesCards, FeaturesWrapper } from "../../components/pages/Features";
import ParallaxHero from "../../components/ParallaxHero";
import Layout from "../../components/layouts/HomeLayout";
const grantPage = require("../../data/grant-page.json");

export default function LandingPage({ content, user, busy, setMobileMenu, mobileMenuIsOpen, handleToast, isTransparent }) {
    const ogImage = content["hero-image"].src.replace("https://www.datocms-assets.com/", "");
    useStoreUTM();
    
    return <>
        <Layout handleToast={handleToast} user={user} busy={busy} setMobileMenu={setMobileMenu} mobileMenuIsOpen={mobileMenuIsOpen} isTransparent={isTransparent}>
            <Head>
                <title>{content.meta.title}</title>
                <meta name="description" content={content.meta.description} />
                <meta name="keywords" content="grant, covalent, program" />
                <meta property="og:description" content={content.meta.description} />
                <meta property="og:title" content="Covalent Grants Program | Covalent" />
                <meta name="og:image" content={`https://covalent-og.vercel.app/api/og?title=${encodeURI(content.meta.title)}&subtitle=${encodeURI("")}&dato=${ogImage}`} />
                <link  rel="preload"  as="image" href="https://www.datocms-assets.com/86369/1700775331-particles-6.jpg" />
                <link
                    rel="canonical"
                    href={`https://www.covalenthq.com/grant/`}
                    key="canonical"
                />
            </Head>
            <div className="landing-page">
                <ParallaxHero imageUrl="https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?dpr=0.25&fm=webp 960w,https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?dpr=0.5&fm=webp 1920w,https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?dpr=0.75&fm=webp 2880w,https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?fm=webp 3840w">
                    <HeroWrapper dark>
                        <div className="overlay" />
                        <GradientDivider />
                        <HeroContent>
                            <HeroBadge>
                        Developer Tools
                                <div className="flex-center">
                                    <span className="small-icon material-symbols-rounded ">chevron_right</span>
                                </div>
                        Grants
                            </HeroBadge>
                            <HeroTitle>
                        Covalent Grants Program (Beta)
                            </HeroTitle>
                            <HeroSubtitle>
                        Introducing Covalant grants! Apply to get up to <span className="highlight">$25,000 USD</span> in incentives for projects looking to build with the richest, deepest, and broadest onchain data.
                            </HeroSubtitle>
                            <div className="spacer"/>
                            <HeroCtas>
                                <HeroCTA><Button href="https://forms.gle/JAyCPqPEXkidBHqf6">Apply Now</Button></HeroCTA>
                            </HeroCtas>
                        </HeroContent>
                        <HeroImage image={content["hero-image"]} />
                    </HeroWrapper>
                    <FeaturesWrapper dark>
                        <FeatureTitle>
                    Grant Details
                        </FeatureTitle>
                        <FeaturesCards>
                            <FeaturesCard dark>
                                <FeaturesCardTitle>
                            Who are grants for?
                                </FeaturesCardTitle>
                                <FeaturesCardDescription>
                            Are you building a multi-chain wallet, or maybe a risk scoring credit system? How about DAO Analytics, or on-chain accounting? Maybe it's something new like predictive analytics or AI? We have created this program to support the projects that exist today, and those looking to get Web3 data to solve problems of tomorrow. 
                                </FeaturesCardDescription>
                            </FeaturesCard>
                            <FeaturesCard>
                                <FeaturesCardTitle>
                            What is the eligibility?
                                </FeaturesCardTitle>
                                <FeaturesCardDescription>
                            To submit your project for consideration, it should meet the following criteria: Projects should have less than two years of operating experience and require a registered Covalent API key. Additionally, your project should have a demo'able product and a live website.
                                </FeaturesCardDescription>
                            </FeaturesCard>
                            <FeaturesCard>
                                <FeaturesCardTitle>
                            What types of grants are these?
                                </FeaturesCardTitle>
                                <FeaturesCardDescription>
                            At this stage grants are issued in premium credits for Covalent's products suite or for novel use cases which require large amounts of data.    
                                </FeaturesCardDescription>
                            </FeaturesCard>
                            <FeaturesCard>
                                <FeaturesCardTitle>
                            How are grants prioritized?
                                </FeaturesCardTitle>
                                <FeaturesCardDescription>
                            Grants are prioritized to those who come via verified partners of the Covalent. Grants will be processed by ease of implementation (leverages existing product suite) followed by those who have BIG ideas on what can be done with full replica's of normalized data from 115+ blockchains. 
                                </FeaturesCardDescription>
                            </FeaturesCard>
                            <FeaturesCard>
                                <FeaturesCardTitle>
                            How will I know if I've been accepted?
                                </FeaturesCardTitle>
                                <FeaturesCardDescription>
                            You will be notified within 30 days from the start of the upcoming calendar month to know if you have been accepted or not. Further information may be requested 
                                </FeaturesCardDescription>
                            </FeaturesCard>
                            <FeaturesCard>
                                <FeaturesCardTitle>
                        Why Covalent grants?
                                </FeaturesCardTitle>
                                <FeaturesCardDescription>
                        The tourists are gone, resources are scarce,  those who are here building are really here because of passion. And with great constraints comes the greatest products. We are looking to support these builders by doing what we do best. Providing lot's of data and find out novel ways for you to consume it. 
                                </FeaturesCardDescription>
                            </FeaturesCard>
                        </FeaturesCards>
                    </FeaturesWrapper>
                    <BenefitsWrapper dark padding="var(--landing-page-padding) var(--landing-page-padding) 0 var(--landing-page-padding)">
                        <BenefitsTitle>
                What can I use Covalent for?
                        </BenefitsTitle>
                        <BenefitsSubtitle>
                Some use cases include:
                        </BenefitsSubtitle>
                        <BenefitsCards>
                            <BenefitsCard>
                                <BenefitsCardImage maxWidth={"100%"} width={"100%"} src={"https://www.datocms-assets.com/86369/1687374973-grants-use-cases.svg"} />
                            </BenefitsCard>
                        </BenefitsCards>
                    </BenefitsWrapper>
                    <HugeCTAWrapper dark>
                        <GradientDivider height={200} />
                        <GradientDividerTop height={200} />
                        <HugeCTATitle>
                    Apply for the Covalent<br/>Grants Program
                        </HugeCTATitle>
                        <div className="spacer-lg"/>
                        <HugeCTACTA>
                            <Button href="https://forms.gle/JAyCPqPEXkidBHqf6">Apply Now</Button>
                        </HugeCTACTA>
                    </HugeCTAWrapper>
                </ParallaxHero>
                <style jsx>{`
        .landing-page{
            overflow:hidden;
        }
        .highlight{
            color: var(--pink);
        }
        .center-self {
            place-self: center;
        }
        .grid-col-span-2 {
            grid-column: span 2;
        }
        @media (max-width: 768px) {
            .grid-col-span-2 {
                grid-column: span 1;
            }
        }
        p {
            color: var(--gray-medium);
        }
        #signup {
            visibility: none;
            position: absolute;
            top: -150px;
        }
        .signup-box {
            max-width: 600px;
            min-width: 500px;
            margin: 0 auto;
            background-image: linear-gradient(135deg,#00d8d521 0%,#ff4c8b33 100%);
            padding: 2rem;
            border-radius: calc(var(--border-radius) * 2);
            position: relative;
            border: 1px solid var(--code-border);
            transition: all 0.2s ease-in-out;
        }
        .signup-box:hover {
            border: 1px solid var(--pink);
            transition: all 0.2s ease-in-out;
        }
        @keyframes backgroundGradient {
            0% {
                background-position: 0% 50%;
                transform: scale(1.01);
            }
            100% {
                background-position: 100% 50%;
                transform: scale(0.98);
            }
        }

        .beta {
            font-size: var(--font-size-6);
            letter-spacing: 0;
        }

        .document-section-large {
            background-image: linear-gradient(135deg,#00d8d521 0%,#ff4c8b33 100%);
            padding: 2rem;
            border-radius: var(--border-radius);
        }

        .document-section-large h3:first-of-type {
            margin-top: 0;
        }

        .document-section-large h3 {
            font-size: var(--font-size-5);
            margin-bottom:var(--landing-page-gap);
        }

        .document-section-large ul {
            color: var(--gray-medium);
        }

        :global(.signup-box::before) {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: linear-gradient(45deg, #ff4c8b80, var(--teal));
            z-index: -1;
            filter: blur(5px);
            border-radius: calc(var(--border-radius) * 2);
            animation: backgroundGradient 4s ease-in-out infinite alternate;
            background-size: 200% 200%;
            // opacity: 0.85;
            transition: all 0.2s ease-in-out;
        }

        :global(.signup-box:hover::before) {
            filter: blur(25px);
            transition: all 0.2s ease-in-out;
            background-image: linear-gradient(45deg, var(--pink), var(--teal));
        }

        :global(.signup-box::after) {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: var(--covalent-dark-blue);
            z-index: -1;
            border-radius: calc(var(--border-radius) * 2);
            // opacity: 0.85;
        }
        :global(.signup-box::after) {
            background-image: linear-gradient(135deg,#00d8d521 0%,#ff4c8b33 100%);
        }
        .flex {
            gap: 2rem;
            z-index: 1;
        }
        .spacer {
            height: 0.5rem;
        }
        .spacer-lg {
            height: 1.5rem;
        }
        .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #00042661;
            z-index: 0;
        }
        .top-title {
            display: block;
        }
        .bottom-title {
            display: block;
            min-height: 102px;
        }
        @media (max-width: 768px) {
            .flex {
                flex-direction: column;
            }
        .place-items-center {
            place-items: center;
        }
        .video-bg{
            display:block;
        }

        @media (max-width: 768px) {
            .video-bg{
                display:none;
            }
            .static-bg{
                display:block;
            }
        }
    `}</style>
            </div>
        </Layout>
    </>;
}

export async function getStaticProps() {
    const content = grantPage;
    const images = await GetAllDatoImages();
    const transformedContent = convertNumberedKeysToArrays(replaceImageValues(content, images));

    return {
        props: {
            component: "LandingPage",
            content: transformedContent,
        },
    };
}
